import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function NavScrollFade({ children, className }) {
    const ref = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);
    const update = useCallback(() => {
        const el = ref.current;
        if (!el)
            return;
        const { scrollLeft, scrollWidth, clientWidth } = el;
        setShowLeft(scrollLeft > 4);
        setShowRight(scrollLeft + clientWidth < scrollWidth - 4);
    }, []);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const raf = requestAnimationFrame(update);
        const ro = new ResizeObserver(update);
        ro.observe(el);
        Array.from(el.children).forEach((child) => ro.observe(child));
        el.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        return () => {
            cancelAnimationFrame(raf);
            el.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
            ro.disconnect();
        };
    }, [update]);
    const scrollBy = (direction) => {
        const el = ref.current;
        if (!el)
            return;
        el.scrollBy({
            left: direction * Math.max(120, el.clientWidth * 0.6),
            behavior: 'smooth',
        });
    };
    const buttonClass = 'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded text-white hover:bg-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
    return (React.createElement("div", { className: classNames('flex min-w-0 flex-1 items-center gap-1', className) },
        React.createElement("div", { className: "w-6 flex-shrink-0" }, showLeft && (React.createElement("button", { type: "button", className: buttonClass, "aria-label": "Scroll navigation left", onClick: () => scrollBy(-1) },
            React.createElement(ChevronLeft, { className: "h-4 w-4" })))),
        React.createElement("div", { ref: ref, className: "min-w-0 flex-1 overflow-x-scroll [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" }, children),
        React.createElement("div", { className: "w-6 flex-shrink-0" }, showRight && (React.createElement("button", { type: "button", className: buttonClass, "aria-label": "Scroll navigation right", onClick: () => scrollBy(1) },
            React.createElement(ChevronRight, { className: "h-4 w-4" }))))));
}
